import React, { useContext, useState } from "react";

import "~/assets/sass/pages/round/roundReg/dynamicForm.scss";
import { PlusIcon } from "~/assets/svg/MathIcon";
import { AppContext } from "../RoundRegContext";
import QuestionCardList from "./QuestionCardList";
import PreviewModal from "./PreviewModal";
import { useTranslation } from "react-i18next";

const Question = ({ questionPreModal, setQuestionPreModal, QuestionWarning }) => {
	const { t } = useTranslation();
	const { addQuestion, qList } = useContext(AppContext);

	return (
		<>
			<div className="dynamic-form-wrap">
				<div className="dynamic-form-head">
					<h3>{t("pages.round.RoundReg.container.Inquiry.h3-1")}</h3>
				</div>
				<QuestionCardList qList={qList} />
				<button className="dashed-btn plus-btn" onClick={addQuestion}>
					<PlusIcon />
					{t("common.commonWord.button.add")}
				</button>
			</div>

			{/*자주 묻는 질문 미리보기 모달*/}
			<PreviewModal {...{ questionPreModal, setQuestionPreModal }} />

			<QuestionWarning
				type="info"
				message={"제목이나 내용이 누락되었습니다."}
				confirm={t("common.commonWord.button.check")}
			/>
		</>
	);
};

export default Question;
